<template>
    <div
      class="modal fade createNewModal"
      id="AddElementModal"
      tabindex="-1"
      ref="addElementModalRef"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content p-15 p-md-40">
          <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
            <h5 class="modal-title fw-bold text-black">{{ title }}</h5>
          </div>
          <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
            <Form ref="elementForm" @submit="addElement" :validation-schema="elementSchema">
                
                <div class="row">

                  <div class="col-md-12">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                      Libelle <span class="text-danger">*</span>
                      </label>
                      <Field name="libelle" type="text" 
                      class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le libelle"/>
                      <ErrorMessage name="libelle" class="text-danger"/>
                  </div>
                  </div>

                  <div class="col-md-12">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                      Description <span class="text-danger">*</span>
                      </label>
                      <Field name="description" type="text" 
                      class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer la description"/>
                      <ErrorMessage name="description" class="text-danger"/>
                  </div>
                  </div>

                  <div class="col-md-12">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Tarif
                      </label>
                      <Field name="tarif" type="text" 
                      class="form-control shadow-none fs-md-15 text-black" placeholder="0"/>
                      <ErrorMessage name="tarif" class="text-danger"/>
                      <!-- <Field name="categorieParent" v-model="categorieSelected"  v-slot="{ field }">
                        <Multiselect
                            v-model = "field.value"
                            v-bind = "field"
                            :options="categorieOptions"
                            :searchable="true"
                            placeholder="Rechercher un element"
                            noResultText= "Aucun enregistrement trouvé"
                            noOptionsText="Tapez au moins deux caractères"/>
                      </Field> -->
                      <!-- <ErrorMessage name="categorieParent" class="text-danger"/> -->
                  </div>
                  </div>

                </div>
                
              
              <button
                class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
                type="submit">
                {{ btntext }}
              </button>
          </Form>
          </div>
          <button
            type="button"
            class="btn-close shadow-none"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="resetValue()"
          ></button>
        </div>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent, ref, watch, onMounted } from 'vue';
  import { Form, Field, ErrorMessage } from 'vee-validate';
  import ApiService from '../../services/ApiService';
  import * as Yup from 'yup';
  import { error , success, hideModal } from '../../utils/utils';
  import Multiselect from '@vueform/multiselect';
  import { Option } from '../../models/Option';
  
  export default defineComponent({
      name: "AddOptionModal",
      components: {
      Form,
      Field,
      ErrorMessage,
      // Multiselect
    },
    props: {
      item: {
        type: Number,
        default: 0,
      }
    },
    setup(props, { emit }){
      const elementSchema = Yup.object().shape({
        libelle: Yup.string().required('Le libelle est obligatoire'),
        description: Yup.string().required('La description est obligatoire'),
        tarif : Yup.number().notRequired(),
      });
  
      
      const elementForm = ref<Option | null>(null);
      const addElementModalRef = ref<null | HTMLElement>(null);
      const categorieSelected = ref(null);
      const categorieOptions = ref([]);
      
      
      const isUPDATE = ref(false);
      const title = ref("Ajouter une option");
      const btntext = ref('Enregistrer');
  
      watch(() => props.item, (newValue) => {
        getOne(newValue);
        isUPDATE.value = true;
        btnTitle();
      });
  
      const btnTitle = async () => {
        if (isUPDATE.value) {
           title.value = "Modifier l'option";
           btntext.value = "Modifier";
        }else{
           title.value = "Ajouter une option";
           btntext.value = "Enregistrer";
        }
      }
  
      const produitsError = ref(false); 
  
     
      const getOne = async (id: number) => {
        return ApiService.get("/option/"+id)
        .then(({ data }) => {
          // map data in form
          const donnees = data.data;
          // const categories = donnees.categories;
  
          // let ids: number[] = [];
          // for (const categorie of categories) {
          //   ids.push(categorie.id); 
          // }
          // categories.value= ids;
  
          // defaultSelectedCategories.value = categories.value
          for (const key in donnees) {
            elementForm.value?.setFieldValue(key, 
            (typeof donnees[key] === 'object' && donnees[key] !== null)? donnees[key].id :donnees[key]
            );
          }
          emit('openmodal', addElementModalRef.value);
  
        })
        .catch(({ response }) => {
          error(response.data.message)
        });
      }


      const fetchFormules = async () => {
            ApiService.get("/options")
            .then(({ data }) => {
              categorieOptions.value = data.data.map((p) => {
                  return { 
                    value: p.id,
                    label: p.libelle,
                  }
              });
            })
            .catch(({ response }) => {
            // produitsError.value = true;
            });
        };

  
      const addElement = async (values: any, elementForm) => {
        
        values = values as Option;
        if(isUPDATE.value){
          ApiService.put("/option/"+values.id,values)
          .then(({ data }) => {
              if(data.code == 200) { 
                success(data.message);
                elementForm.resetForm();
                hideModal(addElementModalRef.value);
                isUPDATE.value=false;
                btnTitle();
                emit('close');
              }
          })
          .catch(({ response }) => {
              error(response.data.message);
          });
        }else{
          ApiService.post("/option",values)
          .then(({ data }) => {
              if(data.code == 201) { 
                success(data.message);
                elementForm.resetForm();
                hideModal(addElementModalRef.value);
                emit('close');
              }
          })
          .catch(({ response }) => {
              error(response.data.message);
          });
        }
      };
     
  
      onMounted(() => {
        fetchFormules();
      });
  
      const resetValue = () => {
        const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
          isUPDATE.value=false;
        formFields.forEach(field => {
          field.value = '';
        });
        btnTitle()
      };
  
      return { 
        elementSchema,
        addElementModalRef,
        addElement,
        elementForm,
        title,btntext,
        resetValue,
        produitsError,
        categorieOptions,
        categorieSelected
      };
    },
  });
  </script>